<div *ngIf="dashboard=='admin_dashboard'">
    <app-dashboard></app-dashboard>
</div>
<div *ngIf="dashboard=='azaan_admin_dashboard'">
  <app-azaan-admin-dashboard></app-azaan-admin-dashboard>
</div>
<div *ngIf="dashboard=='branch-manager-dashboard'">
  <app-branch-manager-dashboard></app-branch-manager-dashboard>
</div>
<div *ngIf="dashboard=='default_dashboard'">
  <app-default-dashboard></app-default-dashboard>
</div>
